import { useEffect, useState } from "react"
import { ReactComponent as LeftSvg } from '../images/left.svg';
import { ReactComponent as RightSvg } from '../images/right.svg';
import './calendar.css';
import { compareDates } from "../pages/utils/utils";

const months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
const calendarDays = ['DOM', 'LUN', 'MAR', 'MIÉ', 'JUE', 'VIE', 'SÁB'];
const dayInSeconds = 86400000;

interface CalendarProps {
    date?: Date,
    onSelectDate: (date: Date) => void,
}

export function Calendar({ date = new Date(), onSelectDate }: CalendarProps) {

    const [selectedDate, setSelectedDate] = useState<Date>(date);
    const [calendar, setCalendar] = useState<Date[]>([]);

    useEffect(() => {
        setCalendar(getCalendarForTheMonth(selectedDate))
    }, [selectedDate])

    function getCalendarForTheMonth(date: Date = new Date()): Date[] {
        const calendar: Date[] = [];
        
        const firstDayOfTheMonth = new Date(date.getFullYear(), date.getMonth(), 1);
        const lastDayOfTheMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);

        for(let i = 0; i < firstDayOfTheMonth.getDay(); i++) {
            calendar.push(new Date(firstDayOfTheMonth.getTime() - dayInSeconds * (firstDayOfTheMonth.getDay() - i)))
        }

        calendar.push(firstDayOfTheMonth);

        for(let i = 1; i < lastDayOfTheMonth.getDate(); i++) {
            calendar.push(new Date(firstDayOfTheMonth.getTime() + dayInSeconds * i));
        }

        if(calendar.length % 7) {
            const lastDay = new Date(calendar[calendar.length - 1]);
            for(let i = 0; i < calendar.length % 7; i++) {
                calendar.push(new Date(lastDay.getTime() + dayInSeconds * (i + 1)));
            }
        }

        return calendar;
    }

    function increaseOneMonth() {
        const date = new Date(selectedDate);
        date.setMonth(selectedDate.getMonth() + 1);
        date.setDate(1);
        setSelectedDate(date);
    }

    function decreaseOneMonth() {
        const date = new Date(selectedDate);
        date.setMonth(selectedDate.getMonth() - 1);
        date.setDate(1);
        setSelectedDate(date);
    }

    function onSelect(date: Date) {
        setSelectedDate(date);
        onSelectDate(date);
    }

    return (
        <div className="calendar">
            <div className="calendar-top">
                <div className="calendar-icon" onClick={() => decreaseOneMonth()}><LeftSvg /></div>
                <p><strong>{months[selectedDate.getMonth()].toUpperCase()} {selectedDate.getFullYear()}</strong></p>
                <div className="calendar-icon" onClick={() => increaseOneMonth()}><RightSvg /></div>
            </div>
            <div className="calendar-grid-day">
                {calendarDays.map((day, index) => <div className="calendar-day" id={day + index}>{day}</div>)}
            </div>
            <div className="calendar-grid">
                {calendar.map((day, index) => {
                    return <div className={compareDates(selectedDate, day) ? "calendar-item calendar-selected" : "calendar-item"} key={index} onClick={() => onSelect(day)}>{day.getDate()}</div>
                })}
            </div>
        </div>
    )
}